import { render, staticRenderFns } from "./ListPopover.vue?vue&type=template&id=37819ca7&"
import script from "./ListPopover.vue?vue&type=script&lang=ts&"
export * from "./ListPopover.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports